import $ from 'jquery';
import debounce from '../lib/utils/debounce';

const selectors = {
    stickyHeader: '.js-sticky-header',
    pageHeader: '.js-page-header',
    fastLinks: '.js-sticky-header-fast-links',
    fastLink: '.js-sticky-header-fast-link'
};

const states = {
    active: 'is-active'
};

const DEBOUNCE_TIMEOUT = 90; // ms
const SCROLL_TIMEOUT = 2000; // ms
const EXTRA_SCROLL_PADDING = 20; // px

let $window;
let $htmlBody;
let $stickyHeader;
let $pageHeader;
let $fastLinks;
let pageHeaderHeight;
let stickyHeaderHeight;

const replaceHash = (anchor) => {
    window.history.replaceState(null, null, `${document.location.href.split('#')[0]}${anchor}`);
};

const setActiveFastLink = function ($target) {
    $target
        .closest(selectors.fastLinks)
        .find(selectors.fastLink)
        .removeClass(states.active);

    $target
        .addClass(states.active);
};

const onScroll = function () {
    pageHeaderHeight = $pageHeader.outerHeight();
    const scrollPos = $window.scrollTop();

    if (scrollPos >= pageHeaderHeight) {
        $stickyHeader.addClass(states.active);
    } else {
        $stickyHeader.removeClass(states.active);
    }

    if (!$stickyHeader.hasClass(states.active)) {
        replaceHash('');
        return;
    }

    $fastLinks.find(selectors.fastLink).each(function () {
        const $currLink = $(this);
        const hash = $currLink.attr('href');
        const $refElement = $(hash);

        if (!$refElement.length) {
            return;
        }

        const refElementTop = $refElement.position().top;
        const normalizedScrollPos = scrollPos + stickyHeaderHeight + EXTRA_SCROLL_PADDING;

        if (refElementTop <= normalizedScrollPos &&
            refElementTop + $refElement.height() > normalizedScrollPos) {

            setActiveFastLink($currLink);
            replaceHash(hash);

        } else {
            $currLink.removeClass(states.active);
        }
    });
};

const debouncedOnScroll = debounce(onScroll, DEBOUNCE_TIMEOUT);

const onFastLinkClick = function (evt) {
    evt.preventDefault();

    $window.off('scroll', debouncedOnScroll);

    const $target = $(evt.currentTarget);
    const hash = $target.attr('href');

    const $ScrollToElem = $(`${hash}`);

    if (!$ScrollToElem.length) {
        return;
    }

    setActiveFastLink($target);

    stickyHeaderHeight = $stickyHeader.outerHeight();

    $htmlBody.stop().animate({
        scrollTop: $ScrollToElem.offset().top - stickyHeaderHeight - EXTRA_SCROLL_PADDING
    }, SCROLL_TIMEOUT, () => {
        replaceHash(hash);
        $window.on('scroll', debouncedOnScroll);
    });
};

const initScrollTo = function () {
    const hash = $window[0].location.hash;

    if (hash === '') {
        return;
    }

    const $scrollToElem = $(hash);

    if (!$scrollToElem.length) {
        return;
    }

    $htmlBody.stop().animate({
        scrollTop: $scrollToElem.offset().top - stickyHeaderHeight - EXTRA_SCROLL_PADDING
    }, 0, () => {
        replaceHash(hash);
    });
};

const stickyHeader = function () {
    $window = $(window);
    $htmlBody = $('html, body');
    $stickyHeader = $(selectors.stickyHeader);
    $pageHeader = $(selectors.pageHeader);

    if (!$stickyHeader.length) {
        return;
    }

    if (!$pageHeader.length) {
        return;
    }

    pageHeaderHeight = $pageHeader.outerHeight();
    stickyHeaderHeight = $stickyHeader.outerHeight();

    if ($window.scrollTop() >= pageHeaderHeight) {
        $stickyHeader.addClass(states.active);
    }

    $window.on('scroll', debouncedOnScroll);

    initScrollTo();

    $fastLinks = $stickyHeader.find(selectors.fastLinks);

    $fastLinks.on('click', `${selectors.fastLink}:not(.${states.active})`, onFastLinkClick);
};

export default stickyHeader;
